import { useQuery } from '@apollo/client';
import useBusinessConfiguration from '../../../../hooks/useBusinessConfiguration';
import { NBTenant } from '../../../../types/enums';
import { getShowOnboardingTourNewbiesCookie, getShowOnboardingTourUpgradersCookie, } from '../../../../utils/cookies';
import GET_EXPERIENCE from './GET_EXPERIENCE';
export var showOnboarding = function (_a) {
    var experimentNewbieValue = _a.experimentNewbieValue, experimentUpgraderValue = _a.experimentUpgraderValue, cookieNewbieValue = _a.cookieNewbieValue, cookieUpgraderValue = _a.cookieUpgraderValue, uesValue = _a.uesValue;
    var seeTourAsUpgrader = experimentUpgraderValue === 'true' && cookieUpgraderValue === 'true';
    var seeTourAsNewbie = experimentNewbieValue === 'true' &&
        (cookieNewbieValue === 'true' ||
            (uesValue && cookieNewbieValue !== 'false'));
    return seeTourAsUpgrader || seeTourAsNewbie;
};
var useOnboarding = function () {
    var cookieNewbieValue = getShowOnboardingTourNewbiesCookie();
    var cookieUpgraderValue = getShowOnboardingTourUpgradersCookie();
    var tenant = useBusinessConfiguration().tenant;
    var data = useQuery(GET_EXPERIENCE, {
        errorPolicy: 'ignore',
        skip: tenant !== NBTenant.IPSY,
    }).data;
    var me = data === null || data === void 0 ? void 0 : data.me;
    return {
        showOnboarding: showOnboarding({
            experimentNewbieValue: me === null || me === void 0 ? void 0 : me.experimentNewbieValue,
            experimentUpgraderValue: me === null || me === void 0 ? void 0 : me.experimentUpgraderValue,
            cookieNewbieValue: cookieNewbieValue,
            cookieUpgraderValue: cookieUpgraderValue,
            uesValue: me === null || me === void 0 ? void 0 : me.uesValue,
        }),
    };
};
export default useOnboarding;
